<section class="hero">
    <img src="assets/images/about.webp" loading="lazy" style="position: relative"  class="hero-img" alt="About Bhagyajit">
</section>